// extracted by mini-css-extract-plugin
export default {"categoriesContainer":"calculationCategories_categoriesContainer__ozU8-","gridContainer":"calculationCategories_gridContainer__0utK8"};